import { createPortal } from 'react-dom'
import { getLocale } from '../lib/i18n'

/** A full-screen "please wait" while a photo is being prepared or sent, so nobody taps twice thinking nothing happened. */
export default function BusyOverlay({ text }: { text?: string }) {
  const label = text ?? (getLocale() === 'en' ? 'Getting your photo ready. Please wait…' : 'Preparando tu foto. Espera un momento…')
  return createPortal(<div className="busy-overlay" role="status" aria-live="assertive"><div className="busy-card"><span className="busy-spin" aria-hidden="true"/><p>{label}</p></div></div>, document.body)
}
